import { LocationQueryValue, RouteLocationNormalizedLoaded } from "vue-router"
export const getFirstQueryValue = (query: LocationQueryValue | LocationQueryValue[]): string | null => {
  if (!query) {
    return null
  } else if (typeof query === "string") {
    return query
  } else {
    return query[0]
  }
}

/**
 * リダイレクト先のURLを取得する
 */
export const getFullRedirectPath = (nextParam: string, { fullPath }: RouteLocationNormalizedLoaded): string => {
  if (!nextParam) return "/mypage"
  const nextUrl = decodeURIComponent(nextParam.toString())
  const queryIndex = fullPath.indexOf("?")
  const queryString = queryIndex >= 0 ? fullPath.substring(queryIndex) : ""
  const currentParams = new URLSearchParams(queryString)
  currentParams.delete("next")
  // LINEログインコールバック時に付与されるパラメータ
  currentParams.delete("code")
  currentParams.delete("state")
  currentParams.delete("liffRedirectUri")
  currentParams.delete("liffClientId")
  currentParams.delete("lineAppVersion")

  const additionalParams = currentParams.toString()

  return additionalParams.length > 1 ? `${nextUrl}${nextUrl.includes("?") ? "&" : "?"}${additionalParams}` : nextUrl
}
